import "./App.css";
import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { isMobile } from "react-device-detect";
import WebCall from "./webcall/WebCall";

// ===== Default page — deep link redirector (existing behavior) =====
function DeepLinkRedirect() {
  const [path, setPath] = useState("");

  const checkDeviceAndRedirect = async () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const pathloc = window.location.pathname;
    const currentPath = pathloc.substring(1);
    console.log("Current Path:", currentPath);
    setPath(currentPath);
    const isAppInstalled =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    const appLink = `guruvice://${currentPath}`;

    if (isAppInstalled) {
      window.location.href = appLink;
      setTimeout(() => {
        if (/android/i.test(userAgent)) {
          console.log("Device is Android");
          if (isMobile && window.navigator.standalone) {
            window.location.href = appLink;
          } else {
            window.location.href =
              "https://play.google.com/store/apps/details?id=com.guruvice";
          }
        } else if (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
          console.log("Device is iOS");
          if (isMobile && window.navigator.standalone) {
            window.location.href = appLink;
          } else {
            window.location.href = "https://testflight.apple.com/join/X1OcOuJi";
          }
        } else {
          console.log("Device is neither Android nor iOS");
          window.location.href = "https://guruvice.com";
        }
      }, 2000);
    }
  };

  useEffect(() => {
    checkDeviceAndRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <p>welcome to guruvice</p>
      </header>
    </div>
  );
}

// ===== Main App with Routing =====
function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Web Video Call — /meet/:token */}
        <Route path="/meet/:token" element={<WebCall />} />

        {/* All other paths — existing deep link redirect behavior */}
        <Route path="*" element={<DeepLinkRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
